import React from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';

const rupiah = (n) => 'Rp ' + Number(n || 0).toLocaleString('id-ID');

// Nominal pembayaran, dengan harga coret opsional (Pengaturan Situs → Fitur On/Off).
// `amount` = nominal yang benar-benar ditagih; default ke paymentAmount di pengaturan.
// Harga coret hanya tampil jika aktif DAN lebih besar dari nominal yang ditagih.
export default function PriceTag({ amount, size = 'md' }) {
  const { settings } = useSiteSettings();
  const price = Number(amount ?? settings.paymentAmount ?? 0);
  const strike = Number(settings.priceStrikeAmount || 0);
  const showStrike = settings.priceStrikeEnabled && strike > price;
  const lg = size === 'lg';

  return (
    <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
      {showStrike && (
        <s style={{ color: 'var(--in-text-faint)', fontSize: lg ? 15 : '0.9em', fontWeight: 500 }}>
          {rupiah(strike)}
        </s>
      )}
      <strong style={{ color: 'var(--in-text)', fontSize: lg ? 22 : '1em', fontWeight: 800 }}>
        {rupiah(price)}
      </strong>
    </span>
  );
}
